const AppConfig = {
  auth: {
    isLoggedIn: 'loggedInLaoSpecial',
    accessToken: 'accessTokenLaoSpecial',
    userRole: 'userRole',
  }
}

export default AppConfig;
